import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function FloatingQuickContact() {
  const location = useLocation();

  const [contactData, setContactData] = useState(() => {
    try {
      const saved = localStorage.getItem("hk_resort_settings");
      if (saved) return JSON.parse(saved);
    } catch (e) {}
    return {
      phone: "+919602588882",
      whatsapp: "919602588882"
    };
  });

  useEffect(() => {
    const handleStorage = () => {
      try {
        const saved = localStorage.getItem("hk_resort_settings");
        if (saved) setContactData(JSON.parse(saved));
      } catch (e) {}
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  // Hide floating icons if disabled in super admin settings or on admin/user dashboard
  if (contactData?.showFloatingContact === false || location.pathname.includes("/admin") || location.pathname.includes("/user-dashboard")) {
    return null;
  }

  const cleanPhone = (contactData.phone || "+919602588882").replace(/[^\d+]/g, "");
  const cleanWhatsapp = (contactData.whatsapp || "919602588882").replace(/[^\d]/g, "");
  const whatsappMsg = encodeURIComponent("Hello HariKunj Resort! I would like to inquire about room availability & luxury package tariffs.");
  const whatsappUrl = `https://wa.me/${cleanWhatsapp}?text=${whatsappMsg}`;

  return (
    <aside className="hk-floating-quick-contact" aria-label="Quick Contact Actions">
      <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="hk-float-btn hk-float-btn--whatsapp" title="Chat on WhatsApp">
        <i className="fab fa-whatsapp hk-float-icon" />
        <span className="hk-float-tooltip">Chat on WhatsApp</span>
      </a>

      <a href={`tel:${cleanPhone}`} className="hk-float-btn hk-float-btn--call" title="Call Reservations">
        <i className="fas fa-phone-alt hk-float-icon" />
        <span className="hk-float-tooltip">Call {contactData.phone || "+91 9602588882"}</span>
      </a>

      <style>{`
        .hk-floating-quick-contact {
          position: fixed;
          bottom: 24px;
          right: 20px;
          left: auto;
          z-index: 9990;
          display: flex;
          flex-direction: column;
          gap: 12px;
          align-items: flex-end;
          user-select: none;
        }

        .hk-float-btn {
          position: relative;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff !important;
          text-decoration: none !important;
          box-shadow: 0 8px 24px rgba(5, 14, 26, 0.35);
          transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.3s ease;
          border: 1.5px solid rgba(255, 255, 255, 0.35);
          backdrop-filter: blur(10px);
        }

        .hk-float-btn:hover {
          transform: scale(1.12) translateY(-2px);
        }

        /* WhatsApp Button Gradient & Pulse */
        .hk-float-btn--whatsapp {
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          box-shadow: 0 8px 22px rgba(37, 211, 102, 0.45);
          animation: hk-float-pulse-green 3s infinite ease-in-out;
        }

        .hk-float-btn--whatsapp:hover {
          box-shadow: 0 12px 28px rgba(37, 211, 102, 0.65);
        }

        /* Call Button Gradient & Pulse */
        .hk-float-btn--call {
          background: linear-gradient(135deg, #FEA116 0%, #D4AF37 100%);
          color: #050E1A !important;
          box-shadow: 0 8px 22px rgba(254, 161, 22, 0.45);
          animation: hk-float-pulse-gold 3s infinite ease-in-out 1.5s;
        }

        .hk-float-btn--call:hover {
          box-shadow: 0 12px 28px rgba(254, 161, 22, 0.65);
        }

        .hk-float-icon {
          font-size: 1.35rem;
        }

        /* Hover Tooltip Label */
        .hk-float-tooltip {
          position: absolute;
          right: 58px;
          left: auto;
          background: rgba(11, 29, 55, 0.95);
          color: #FAF6F0;
          font-family: 'Poppins', sans-serif;
          font-size: 0.78rem;
          font-weight: 600;
          white-space: nowrap;
          padding: 5px 12px;
          border-radius: 30px;
          border: 1px solid rgba(212, 175, 55, 0.4);
          box-shadow: 0 8px 20px rgba(5, 14, 26, 0.4);
          opacity: 0;
          visibility: hidden;
          pointer-events: none;
          transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease;
          transform: translateX(6px);
        }

        .hk-float-btn:hover .hk-float-tooltip {
          opacity: 1;
          visibility: visible;
          transform: translateX(0);
        }

        @keyframes hk-float-pulse-green {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5); }
          50% { box-shadow: 0 0 0 12px rgba(37, 211, 102, 0); }
        }

        @keyframes hk-float-pulse-gold {
          0%, 100% { box-shadow: 0 0 0 0 rgba(254, 161, 22, 0.5); }
          50% { box-shadow: 0 0 0 12px rgba(254, 161, 22, 0); }
        }

        /* Mobile tweaks: perfectly fitted 44px */
        @media (max-width: 768px) {
          .hk-floating-quick-contact {
            bottom: 18px;
            right: 14px;
            left: auto;
            gap: 10px;
          }
          .hk-float-btn {
            width: 44px;
            height: 44px;
          }
          .hk-float-icon {
            font-size: 1.2rem;
          }
          .hk-float-tooltip {
            display: none;
          }
        }
      `}</style>
    </aside>
  );
}
